<template>
  <div v-if="visible" class="popup-overlay">
    <div class="popup-container">
      <div class="popup-title">{{ props.title }}</div>
      <p class="popup-text">
        {{ props.description }}
      </p>
      <div class="popup-actions">
        <label class="popup-checkbox">
          <input type="checkbox" v-model="doNotShowAgain" />
          <span>Больше не показывать</span>
        </label>
        <button @click="closePopup" class="popup-button">
          Закрыть
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: 'Информация',
  },
  description: {
    type: String,
    default: '',
  },
})

const STORAGE_KEY = 'hide_info_chain_popup'
const visible = ref(false)
const doNotShowAgain = ref(false)

onMounted(() => {
  const saved = sessionStorage.getItem(STORAGE_KEY)
  if (saved !== 'true') {
    visible.value = true
  }
})

const closePopup = () => {
  if (doNotShowAgain.value) {
    sessionStorage.setItem(STORAGE_KEY, 'true')
  }
  visible.value = false
}
</script>

<style scoped lang="scss">
.popup-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-container {
    background-color: #1f1f1f;
    color: #f0f0f0;
    border: 1px solid #444;
    border-radius: 16px;
    padding: 24px;
    max-width: 600px;
    width: 70%;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);

    .popup-title {
      font-size: 1.25rem;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .popup-text {
      font-size: 0.95rem;
      margin-bottom: 20px;
    }

    .popup-checkbox {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 0.9rem;
    }

    .popup-actions {
      display: flex;
      justify-content: space-around;

      .popup-button {
        background-color: #3b82f6;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 8px 16px;
        font-size: 0.95rem;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
          background-color: #2563eb;
        }
      }
    }
  }
}
</style>
